var map = {
	"./button-pressed-glow.png": 33,
	"./circle-red.png": 34,
	"./circle-white.png": 35,
	"./drums-button-pressed-background.png": 36,
	"./drums-button.png": 37,
	"./guitar-button-pressed-background.png": 38,
	"./guitar-button.png": 39,
	"./key-black-background.png": 40,
	"./key-black.png": 41,
	"./key-white-pressed.png": 42,
	"./key-white.png": 43,
	"./loop-button-icon.png": 44,
	"./loop-button-note.png": 45,
	"./loop-button.png": 46,
	"./piano-button-pressed-background.png": 47,
	"./piano-button.png": 48,
	"./sound/drum_spelen.mp3": 49,
	"./sound/drums/10_A2.mp3": 50,
	"./sound/drums/11_A#2.mp3": 51,
	"./sound/drums/12_B2.mp3": 52,
	"./sound/drums/13_C3.mp3": 53,
	"./sound/drums/14_C#3.mp3": 54,
	"./sound/drums/15_D3.mp3": 55,
	"./sound/drums/16_D#3.mp3": 56,
	"./sound/drums/17_E3.mp3": 57,
	"./sound/drums/1_C2.mp3": 58,
	"./sound/drums/2_C#2.mp3": 59,
	"./sound/drums/3_D2.mp3": 60,
	"./sound/drums/4_D#2.mp3": 61,
	"./sound/drums/5_E2.mp3": 62,
	"./sound/drums/6_F2.mp3": 63,
	"./sound/drums/7_F#2.mp3": 64,
	"./sound/drums/8_G2.mp3": 65,
	"./sound/drums/9_G#2.mp3": 66,
	"./sound/gitaar_spelen.mp3": 67,
	"./sound/guitar/10_A2.mp3": 68,
	"./sound/guitar/11_A#2.mp3": 69,
	"./sound/guitar/12_B2.mp3": 70,
	"./sound/guitar/13_C3.mp3": 71,
	"./sound/guitar/14_C#3.mp3": 72,
	"./sound/guitar/15_D3.mp3": 73,
	"./sound/guitar/16_D#3.mp3": 74,
	"./sound/guitar/17_E3.mp3": 75,
	"./sound/guitar/1_C2.mp3": 76,
	"./sound/guitar/2_C#2.mp3": 77,
	"./sound/guitar/3_D2.mp3": 78,
	"./sound/guitar/4_D#2.mp3": 79,
	"./sound/guitar/5_E2.mp3": 80,
	"./sound/guitar/6_F2.mp3": 81,
	"./sound/guitar/7_F#2.mp3": 82,
	"./sound/guitar/8_G2.mp3": 83,
	"./sound/guitar/9_G#2.mp3": 84,
	"./sound/kies_zelf_een_instrument_en_bespeel_deze_op_de_piano.mp3": 85,
	"./sound/loops/loop1.wav": 86,
	"./sound/loops/loop2.wav": 87,
	"./sound/loops/loop3.wav": 88,
	"./sound/loops/loop4.wav": 89,
	"./sound/piano/10_A2.mp3": 90,
	"./sound/piano/11_A#2.mp3": 91,
	"./sound/piano/12_B2.mp3": 92,
	"./sound/piano/13_C3.mp3": 93,
	"./sound/piano/14_C#3.mp3": 94,
	"./sound/piano/15_D3.mp3": 95,
	"./sound/piano/16_D#3.mp3": 96,
	"./sound/piano/17_E3.mp3": 97,
	"./sound/piano/1_C2.mp3": 98,
	"./sound/piano/2_C#2.mp3": 99,
	"./sound/piano/3_D2.mp3": 100,
	"./sound/piano/4_D#2.mp3": 101,
	"./sound/piano/5_E2.mp3": 102,
	"./sound/piano/6_F2.mp3": 103,
	"./sound/piano/7_F#2.mp3": 104,
	"./sound/piano/8_G2.mp3": 105,
	"./sound/piano/9_G#2.mp3": 106,
	"./sound/piano_spelen.mp3": 107,
	"./sound/trompet_spelen.mp3": 108,
	"./sound/trumpet/10_A2.mp3": 109,
	"./sound/trumpet/11_A#2.mp3": 110,
	"./sound/trumpet/12_B2.mp3": 111,
	"./sound/trumpet/13_C3.mp3": 112,
	"./sound/trumpet/14_C#3.mp3": 113,
	"./sound/trumpet/15_D3.mp3": 114,
	"./sound/trumpet/16_D#3.mp3": 115,
	"./sound/trumpet/17_E3.mp3": 116,
	"./sound/trumpet/1_C2.mp3": 117,
	"./sound/trumpet/2_C#2.mp3": 118,
	"./sound/trumpet/3_D2.mp3": 119,
	"./sound/trumpet/4_D#2.mp3": 120,
	"./sound/trumpet/5_E2.mp3": 121,
	"./sound/trumpet/6_F2.mp3": 122,
	"./sound/trumpet/7_F#2.mp3": 123,
	"./sound/trumpet/8_G2.mp3": 124,
	"./sound/trumpet/9_G#2.mp3": 125,
	"./trumpet-button-pressed-background.png": 126,
	"./trumpet-button.png": 127
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 227;


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared ^\.\/.*$
// module id = 227
// module chunks = 0